import { SVGProps } from 'react'

const WorldIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_11956_138270)">
        <path
          d="M9 0C7.21997 0 5.47991 0.527841 3.99987 1.51677C2.51983 2.50571 1.36628 3.91131 0.685088 5.55585C0.00389957 7.20038 -0.17433 9.00998 0.172937 10.7558C0.520204 12.5016 1.37737 14.1053 2.63604 15.364C3.89472 16.6226 5.49836 17.4798 7.24419 17.8271C8.99002 18.1743 10.7996 17.9961 12.4442 17.3149C14.0887 16.6337 15.4943 15.4802 16.4832 14.0001C17.4722 12.5201 18 10.78 18 9C17.9974 6.61384 17.0484 4.32616 15.3611 2.63889C13.6738 0.951621 11.3862 0.00258081 9 0V0ZM15.4853 5.25H13.0695C12.5287 3.99674 11.8167 2.82456 10.9538 1.767C12.8636 2.2867 14.4917 3.5381 15.4853 5.25ZM12.375 9C12.3688 9.76361 12.2485 10.522 12.018 11.25H5.982C5.75149 10.522 5.63116 9.76361 5.625 9C5.63116 8.2364 5.75149 7.47801 5.982 6.75H12.018C12.2485 7.47801 12.3688 8.2364 12.375 9ZM6.5835 12.75H11.4165C10.7799 14.0068 9.96612 15.1656 9 16.191C8.03353 15.1659 7.21968 14.007 6.5835 12.75ZM6.5835 5.25C7.22008 3.9932 8.03389 2.83437 9 1.809C9.96648 2.83408 10.7803 3.99297 11.4165 5.25H6.5835ZM7.05 1.767C6.18575 2.82434 5.47244 3.99652 4.9305 5.25H2.51475C3.50915 3.53732 5.13875 2.28582 7.05 1.767ZM1.84575 6.75H4.425C4.23057 7.48436 4.12977 8.24035 4.125 9C4.12977 9.75965 4.23057 10.5156 4.425 11.25H1.84575C1.38476 9.78542 1.38476 8.21458 1.84575 6.75ZM2.51475 12.75H4.9305C5.47244 14.0035 6.18575 15.1757 7.05 16.233C5.13875 15.7142 3.50915 14.4627 2.51475 12.75ZM10.9538 16.233C11.8167 15.1754 12.5287 14.0033 13.0695 12.75H15.4853C14.4917 14.4619 12.8636 15.7133 10.9538 16.233ZM16.1543 11.25H13.575C13.7694 10.5156 13.8702 9.75965 13.875 9C13.8702 8.24035 13.7694 7.48436 13.575 6.75H16.1528C16.6137 8.21458 16.6137 9.78542 16.1528 11.25H16.1543Z"
          fill="#1A1E3D"
        />
      </g>
      <defs>
        <clipPath id="clip0_11956_138270">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default WorldIcon
